import { Component, type ErrorInfo, type ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * Fängt Darstellungsfehler einer Seite ab, damit Navigation und übrige Anwendung benutzbar bleiben.
 */
export class ErrorBoundary extends Component<{ children: ReactNode; resetKey?: string }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Darstellungsfehler', error, info.componentStack);
  }

  componentDidUpdate(prev: { resetKey?: string }) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="mx-auto mt-10 max-w-lg rounded-lg border border-red-200 bg-white p-6 text-center shadow-card">
        <AlertTriangle className="mx-auto h-8 w-8 text-red-500" />
        <h2 className="mt-3 text-lg font-semibold text-slate-900">Diese Seite konnte nicht angezeigt werden</h2>
        <p className="mt-1 text-sm text-slate-600">Bitte laden Sie die Seite neu. Bleibt der Fehler bestehen, informieren Sie den Administrator.</p>
        <button type="button" className="mt-4 rounded-md bg-brand-700 px-4 py-2 text-sm font-medium text-white hover:bg-brand-800" onClick={() => window.location.reload()}>
          Seite neu laden
        </button>
      </div>
    );
  }
}
